/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactTable from "react-table";
import orderBy from "lodash/orderBy";

import * as customerActions from "../../actions/customerActions";
import * as codeActions from "../../actions/codeActions";
import * as userActions from "../../actions/userActions";

import Loading from "../common/Loading";
import { DropdownSearchWithNoFormsy } from "../common/DropdownSearch";

import { SupportResources } from "./components";

import "./SupportResourcesList.scss";

const SupportResourcesList = ({
  data,
  loading,
  refetching,
  onPageChange,
  page,
  onProjectChange,
  actions,
  codes,
  users,
  auth
}) => {
  const [expanded, setExpanded] = useState({});
  const [innerData, setInnerData] = useState([]);

  useEffect(() => {
    actions.loadCodes();
    actions.loadUsers();
  }, [actions]);

  useEffect(() => {
    const allExpanded = {};
    data.result.forEach((row, index) => {
      allExpanded[index] = true;
    });
    setExpanded(allExpanded);
  }, [data]);

  useEffect(() => {
    if (data.result && data.result.length) {
      setInnerData(
        data.result.map((customer) => ({
          ...customer,
          projects: customer.projects.map((project) => ({
            ...project,
            supportResources: project.supportResources?.length
              ? project.supportResources.map((sr) => ({
                  employee: sr.employee,
                  text: sr.order,
                  id: sr.order
                }))
              : [{ text: 1, id: 1 }]
          }))
        }))
      );
    }
  }, [data]);

  const employeeOptions = useMemo(
    () =>
      orderBy(
        users.map((user) => ({
          value: user._id,
          label: `${user.first_name} ${user.last_name}`
        })),
        "label"
      ),
    [users]
  );

  const codeOptions = useMemo(
    () =>
      orderBy(
        codes
          .filter(
            (c) => c.entity === "Project" && c.field === "assignment_type"
          )
          .map((code) => ({ value: code._id, label: code.label })),
        "label"
      ),
    [codes]
  );

  const handleRowToggle = (rowIndex) => {
    setExpanded((prevExpanded) => ({
      ...prevExpanded,
      [rowIndex]: !prevExpanded[rowIndex]
    }));
  };

  const handleAsigmentStyleChange = (customerId, projectId, value) => {
    setInnerData((prev) =>
      prev.map((item) =>
        item._id === customerId
          ? {
              ...item,
              projects: item.projects.map((project) =>
                project._id === projectId
                  ? { ...project, ticketAssignmentStyle: value.value }
                  : project
              )
            }
          : item
      )
    );
    onProjectChange(projectId, {
      ticketAssignmentStyle: value.value,
      supportResources: []
    });
  };

  const handleSupportResourcesChange = (customerId, projectId, value) => {
    setInnerData((prev) =>
      prev.map((item) =>
        item._id === customerId
          ? {
              ...item,
              projects: item.projects.map((project) =>
                project._id === projectId
                  ? { ...project, supportResources: value }
                  : project
              )
            }
          : item
      )
    );

    if (!value.some((v) => !v.employee)) {
      onProjectChange(projectId, { supportResources: value });
    }
  };

  const columns = [
    {
      accessor: "customerName",
      Cell: ({ value }) => (
        <div style={{ background: "rgba(80, 172, 203, 0.2)", padding: 10 }}>
          <b>{value}</b>
        </div>
      )
    }
  ];

  const projectColumns = [
    { Header: "Project Name", accessor: "name", maxWidth: 250 },
    {
      Header: "Assignment Style",
      accessor: "ticketAssignmentStyle",
      Cell: ({ original }) => (
        <div
          className="form"
          style={{ paddingLeft: 15, paddingRight: 15, paddingTop: 20 }}
        >
          <DropdownSearchWithNoFormsy
            rowStyles={{ marginTop: 0 }}
            rowClassNames=""
            name="ticketAssignmentStyle"
            onChange={(_, v) => {
              handleAsigmentStyleChange(original.customer, original._id, v);
            }}
            value={original.ticketAssignmentStyle}
            data={codeOptions}
            disabled={refetching}
            menuPortalTarget={document.body}
            styles={{
              menu: (provided) => ({
                ...provided,
                background: auth.isNightMode ? "#202832" : "#fff",
                color: auth.isNightMode ? "#fff" : "#000"
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: auth.isNightMode
                  ? "#202832"
                  : state.isSelected
                    ? provided.backgroundColor
                    : "transparent",
                "&:hover": {
                  backgroundColor: auth.isNightMode
                    ? state.isDisabled
                      ? "transparent"
                      : "#343B44"
                    : provided.backgroundColor
                }
              })
            }}
          />
        </div>
      )
    },
    {
      Header: "Support Resources",
      accessor: "supportResources",
      Cell: ({ original }) => (
        <SupportResources
          resources={original.supportResources}
          onChangeSupportResources={(resources) => {
            handleSupportResourcesChange(
              original.customer,
              original._id,
              resources
            );
          }}
          employeeOptions={employeeOptions}
          isNightMode={auth.isNightMode}
          disabled={refetching}
          showTicketAssignmentStyle={false}
          ticketAssignmentStyle={original.ticketAssignmentStyle}
          showHeader={false}
          contentStyle={{
            border: `1px solid #d3d3d3`,
            borderRadius: "4px",
            maxHeight: 500,
            padding: "10px 0 10px 10px"
          }}
          projectId={original._id}
        />
      )
    }
  ];

  if (data.count === 0 && !loading) {
    return (
      <div className="loading" style={{ textAlign: "center" }}>
        <h4 style={{ opacity: 0.15 }}>No Data</h4>
      </div>
    );
  }

  if (loading && !refetching) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center"
        }}
      >
        <Loading active={loading} />
      </div>
    );
  }

  return (
    <div className="content-wrapper" style={{ marginLeft: 0, marginRight: 0 }}>
      <ReactTable
        className="rt-project-keywords-customer-list rt-support-resources-list"
        data={innerData}
        showPageSizeOptions={false}
        showPagination
        noDataText="No rows found"
        manual
        columns={columns}
        pageSize={Math.min(data.result.length, 10)}
        pages={Math.floor(data.count / 10)}
        page={page}
        onPageChange={onPageChange}
        expanded={expanded}
        onExpandedChange={(newExpanded, index) => handleRowToggle(index)}
        SubComponent={({ original }) => (
          <ReactTable
            className="rt-project-keywords-projects-list rt-support-resources-project-list"
            data={original.projects}
            columns={projectColumns}
            showPagination={false}
            showPageSizeOptions={false}
            pageSize={original.projects.length}
            manual
          />
        )}
      />
    </div>
  );
};

SupportResourcesList.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  refetching: PropTypes.bool,
  onPageChange: PropTypes.func,
  page: PropTypes.number,
  onProjectChange: PropTypes.func,
  codes: PropTypes.array,
  users: PropTypes.array,
  auth: PropTypes.object
};

SupportResourcesList.defaultProps = {
  data: {
    result: [],
    count: 0
  },
  codes: [],
  users: []
};

function mapStatesToProps(state) {
  return {
    data: state.reducers.withSupportResourcesProjects,
    loading: state.reducers.loading,
    auth: state.reducers.auth,
    codes: state.reducers.codes,
    users: state.reducers.users
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...customerActions,
        ...codeActions,
        ...userActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(SupportResourcesList);
